import type { ArcGisClassBreaksRendererJson } from '../map/buildDefectRulesRenderer';
import { LINE_CONDITION_RAG_BANDS } from './lineConditionBands';

export function buildLineConditionRenderer(
  lineWidth: number = 3,
  lineStyle: string = 'solid',
): ArcGisClassBreaksRendererJson {
  const width = Math.max(1, lineWidth);
  const style = lineStyle.trim() || 'solid';

  return {
    type: 'class-breaks',
    field: 'condition',
    defaultSymbol: {
      type: 'simple-line',
      color: LINE_CONDITION_RAG_BANDS[0].color,
      width,
      style,
    },
    classBreakInfos: LINE_CONDITION_RAG_BANDS.map((band) => ({
      minValue: band.min,
      maxValue: band.max,
      symbol: {
        type: 'simple-line',
        color: band.color,
        width,
        style,
      },
    })),
  };
}
